import { connect } from 'react-redux'

import {
  getJobs,
  fetchJobs,
  setSelectedJob,
  setAddJobAddress,
  setAddJobLocation,
} from '../../../modules/job'
import { fetchUserInfo, getUserInfo } from '../../../modules/organization'

const mapStateToProps = (state) => ({
  userInfo: getUserInfo(state),
  jobList: getJobs(state),
})

const mapDispatchToProps = (dispatch) => ({
  dispatchFetchUserInfo: () => dispatch(fetchUserInfo.request()),
  dispatchFetchJobs: (sortBy) => dispatch(fetchJobs.request(sortBy)),
  dispatchSetSelectedJob: (jobId) => dispatch(setSelectedJob(jobId)),
  dispatchSetAddJobAddress: (address) => dispatch(setAddJobAddress(address)),
  dispatchSetAddJobLocation: (location) => dispatch(setAddJobLocation(location)),
})

const redux = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component)

export default redux
